import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ContextProvider from "./components/ContextProvider";
import "./index.scss";
import 'react-responsive-modal/styles.css';

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<ContextProvider>
				<App />
			</ContextProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
